import script from "./afternoon.vue?vue&type=script&setup=true&lang=js"
export * from "./afternoon.vue?vue&type=script&setup=true&lang=js"

import "./afternoon.vue?vue&type=style&index=0&id=0a71fbec&lang=scss&scoped=true"
script.__scopeId = "data-v-0a71fbec"

export default script